import axios from 'axios';
import { useState, useEffect } from "react";
import { BiSolidCheckCircle } from "react-icons/bi";


export default function MarketStep2({ Market, selectedData, getTemplate }) {
  const [TemplateList, setTemplateList] = useState([]);

  const handleTemplateChange = (e) => {
    const newValue = e.target.value;
    getTemplate(newValue);
  }
  useEffect(() => {
    console.log('step2에서 받는 selectedData', selectedData);
    //마켓별 템플릿 불러오는 API
    axios({
      method: 'POST',
      url: `${window.location.protocol}//${window.location.hostname}:3001/getTemplate`,
      data: {
        token: localStorage.getItem('token'),
        marketCode: selectedData.market,
        loginId: selectedData.marketID
      },
      xhrFields: {
        withCredentials: true,
      },
    })
      .then((res) => {
        setTemplateList(res.data.map(m => {
          return {
            id: m.idx,
            label: m.name
          }
        }));
      })
      .catch();
  }, [])
  return (
    <>
      <h3><span className={selectedData.template ? 'on' : ''}><BiSolidCheckCircle /></span>템플릿 선택</h3>
      <div className='radioItem'>
        {TemplateList.map((el, index) => (
          <label key={index} className={selectedData.template == el.id ? 'on' : ''}>
            <input
              type='radio'
              name='template'
              value={el.id || ''}
              onChange={handleTemplateChange}
              checked={selectedData.template == el.id}
            />
            <span>{el.label}</span>
          </label>
        ))}
      </div>
    </>
  )
}
